import { FormattedMessage } from 'dibs-react-intl';

const messages = {
    styles: <FormattedMessage id="sitemap.navigation.styles" defaultMessage="Styles" />,
    period: <FormattedMessage id="sitemap.navigation.period" defaultMessage="Period" />,
    origin: <FormattedMessage id="sitemap.navigation.origin" defaultMessage="Place of Origin" />,
    materials: <FormattedMessage id="sitemap.navigation.materials" defaultMessage="Materials" />,
    techniques: <FormattedMessage id="sitemap.navigation.techniques" defaultMessage="Techniques" />,
    dealers: <FormattedMessage id="sitemap.navigation.dealers" defaultMessage="Dealers" />,
    locations: <FormattedMessage id="sitemap.navigation.locations" defaultMessage="Locations" />,
    creators: <FormattedMessage id="sitemap.navigation.creators" defaultMessage="Creators" />,
    items: <FormattedMessage id="sitemap.navigation.items" defaultMessage="Items" />,
    gemstones: <FormattedMessage id="sitemap.navigation.gemstones" defaultMessage="Gemstones" />,
    stoneCuts: <FormattedMessage id="sitemap.navigation.stoneCuts" defaultMessage="Stone Cuts" />,
    caratWeight: (
        <FormattedMessage id="sitemap.navigation.caratWeight" defaultMessage="Carat Weight" />
    ),
    metals: <FormattedMessage id="sitemap.navigation.metals" defaultMessage="Metals" />,
    medium: <FormattedMessage id="sitemap.navigation.medium" defaultMessage="Medium" />,
    designs: <FormattedMessage id="sitemap.navigation.designs" defaultMessage="Designs" />,
    designSeries: (
        <FormattedMessage id="sitemap.navigation.designSeries" defaultMessage="Design Series" />
    ),
    artSize: <FormattedMessage id="sitemap.navigation.artSize" defaultMessage="Size" />,
    artOrientation: (
        <FormattedMessage id="sitemap.navigation.artOrientation" defaultMessage="Orientation" />
    ),
    framingStatus: (
        <FormattedMessage id="sitemap.navigation.framingStatus" defaultMessage="Framing" />
    ),
    jewelryType: (
        <FormattedMessage id="sitemap.navigation.jewelryType" defaultMessage="Jewelry type" />
    ),
    ringSize: <FormattedMessage id="sitemap.navigation.ringSize" defaultMessage="Ring Size" />,
};

export const sitemapNavigationLinks = {
    nav: {
        furniture: [
            {
                label: 'style',
                title: messages.styles,
                href: '/sitemap/furniture/style/',
            },
            {
                label: 'period',
                title: messages.period,
                href: '/sitemap/furniture/period/',
            },
            {
                label: 'origin',
                title: messages.origin,
                href: '/sitemap/furniture/origin/',
            },
            {
                label: 'material',
                title: messages.materials,
                href: '/sitemap/furniture/material/',
            },
            {
                label: 'technique',
                title: messages.techniques,
                href: '/sitemap/furniture/technique/',
            },
            {
                label: 'dealers',
                title: messages.dealers,
                href: '/sitemap/furniture/dealers/',
            },
            {
                label: 'locations',
                title: messages.locations,
                href: '/sitemap/furniture/locations/',
            },
            {
                label: 'creators',
                title: messages.creators,
                href: '/sitemap/furniture/creators/',
            },
            {
                label: 'items',
                title: messages.items,
                href: '/sitemap/furniture/items/',
            },
            {
                label: 'designs',
                title: messages.designs,
                href: '/sitemap/furniture/designs/',
            },
            {
                label: 'designSeries',
                title: messages.designSeries,
                href: '/sitemap/furniture/design-series/',
            },
        ],
        jewelry: [
            {
                label: 'style',
                title: messages.styles,
                href: '/sitemap/jewelry/style/',
            },
            {
                label: 'period',
                title: messages.period,
                href: '/sitemap/jewelry/period/',
            },
            {
                label: 'stone',
                title: messages.gemstones,
                href: '/sitemap/jewelry/stone/',
            },
            {
                label: 'stoneCut',
                title: messages.stoneCuts,
                href: '/sitemap/jewelry/stone-cut/',
            },
            {
                label: 'caratWeight',
                title: messages.caratWeight,
                href: '/sitemap/jewelry/carat-weight/',
            },
            {
                label: 'metal',
                title: messages.metals,
                href: '/sitemap/jewelry/metal/',
            },
            {
                label: 'dealers',
                title: messages.dealers,
                href: '/sitemap/jewelry/dealers/',
            },
            {
                label: 'locations',
                title: messages.locations,
                href: '/sitemap/jewelry/locations/',
            },
            {
                label: 'creators',
                title: messages.creators,
                href: '/sitemap/jewelry/creators/',
            },
            {
                label: 'items',
                title: messages.items,
                href: '/sitemap/jewelry/items/',
            },
            {
                label: 'designs',
                title: messages.designs,
                href: '/sitemap/jewelry/designs/',
            },
            {
                label: 'designSeries',
                title: messages.designSeries,
                href: '/sitemap/jewelry/design-series/',
            },
            {
                label: 'jewelryType',
                title: messages.jewelryType,
                href: '/sitemap/jewelry/jewelry-type/',
            },
            {
                label: 'ringSize',
                title: messages.ringSize,
                href: '/sitemap/jewelry/ring-size/',
            },
        ],
        art: [
            {
                label: 'style',
                title: messages.styles,
                href: '/sitemap/art/style/',
            },
            {
                label: 'material',
                title: messages.medium,
                href: '/sitemap/art/material/',
            },
            {
                label: 'dealers',
                title: messages.dealers,
                href: '/sitemap/art/dealers/',
            },
            {
                label: 'locations',
                title: messages.locations,
                href: '/sitemap/art/locations/',
            },
            {
                label: 'creators',
                title: messages.creators,
                href: '/sitemap/art/creators/',
            },
            {
                label: 'items',
                title: messages.items,
                href: '/sitemap/art/items/',
            },
            {
                label: 'framingStatus',
                title: messages.framingStatus,
                href: '/sitemap/art/framing/framed/',
            },
            {
                label: 'artOrientation',
                title: messages.artOrientation,
                href: '/sitemap/art/art-shape/',
            },
            {
                label: 'artSize',
                title: messages.artSize,
                href: '/sitemap/art/art-size/',
            },
        ],
        fashion: [
            {
                label: 'dealers',
                title: messages.dealers,
                href: '/sitemap/fashion/dealers/',
            },
            {
                label: 'locations',
                title: messages.locations,
                href: '/sitemap/fashion/locations/',
            },
            {
                label: 'creators',
                title: messages.creators,
                href: '/sitemap/fashion/creators/',
            },
            {
                label: 'items',
                title: messages.items,
                href: '/sitemap/fashion/items/',
            },
            {
                label: 'designs',
                title: messages.designs,
                href: '/sitemap/fashion/designs/',
            },
        ],
    },
    defaultTypes: {
        furniture: 'style',
        jewelry: 'style',
        art: 'style',
        fashion: 'dealers',
    },
};
